// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/icon?family=Material+Icons);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ------------------------------------------------------------
   Fonts (Roboto + Material Icons)
------------------------------------------------------------ */

/* ------------------------------------------------------------
   Variables / Reset
------------------------------------------------------------ */
:root{
  --bg: #f5f7fa;
  --card: #ffffff;
  --text: #1a1a1a;
  --muted: #505050;
  --blue: #4285f4;
  --blue-dark: #3068c9;
  --green:#34a853;
  --yellow:#fbbc05;
  --red:#ea4335;

  --shadow-1: 0 6px 24px rgba(60,72,88,.13), 0 1px 4px rgba(60,72,88,.08);
  --shadow-2: 0 2px 6px rgba(0,0,0,.05);

  --radius-lg: 18px;
  --radius-md: 13px;
  --radius-sm: 9px;
  
  --padding-mobile: 16px;
  --padding-desktop: 28px;
}

*,
*::before,
*::after { 
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

html, body { 
  height: 100%;
  overflow-x: hidden;
}

body{
  margin: 0;
  font-family: 'Roboto', Arial, sans-serif;
  color: var(--text);
  background: var(--bg);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 100vh;
}

.material-icons{
  font-family: 'Material Icons';
  font-weight: normal;
  font-style: normal;
  font-size: 1.2em;
  display: inline-block;
  line-height: 1;
  text-transform: none;
  letter-spacing: normal;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  -webkit-font-feature-settings: 'liga';
  -webkit-font-smoothing: antialiased;
  vertical-align: middle;
}
.icon-blue{ color: var(--blue); }

/* ------------------------------------------------------------
   Container principal
------------------------------------------------------------ */
.google-form-main{
  width: 100%;
  max-width: 480px;
  margin: 0;
  background: var(--card);
  border-radius: 0;
  box-shadow: none;
  overflow: hidden;
  animation: fadeIn 0.6s ease-in-out;
  min-height: 100vh;
}

@media (min-width: 768px) {
  .google-form-main{
    max-width: 640px;
    margin: 40px auto;
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-1);
    min-height: auto;
  }
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: translateY(0); }
}

/* ------------------------------------------------------------
   Header
------------------------------------------------------------ */
.g-header{
  padding: var(--padding-mobile) var(--padding-mobile) 16px;
  text-align: center;
  background: #fff;
  border: none;
}

@media (min-width: 768px) {
  .g-header{
    padding: var(--padding-desktop) 20px 18px;
  }
}

.gif-top{
  width: 100%;
  background: #fff;
  display: flex;
  justify-content: center;
  padding: 0;
  overflow: hidden;
}

.g-gif{
  width: 100%;
  height: clamp(250px, 50vw, 400px);
  object-fit: contain;
}

@keyframes pulse {
  0% { box-shadow: 0 6px 16px rgba(0,0,0,.08); }
  50%{ box-shadow: 0 6px 28px rgba(0,0,0,.14); }
  100%{ box-shadow: 0 6px 16px rgba(0,0,0,.08); }
}
.pulse { animation: pulse 2.2s ease-in-out infinite; }

.loading-text{
  font-size: clamp(0.85rem, 2.5vw, 0.95rem);
  color: #666;
  margin-top: 10px;
  font-style: italic;
}

.g-header h1{
  font-size: clamp(1.2rem, 4vw, 1.4rem);
  margin: 12px 0 10px;
  line-height: 1.3;
}

.g-header p{
  max-width: 420px;
  margin: 0 auto;
  font-size: clamp(0.88rem, 2.5vw, 0.98rem);
  color: #444;
  line-height: 1.6;
  padding: 0 8px;
}

.g-divider{
  width: clamp(100px, 40%, 180px);
  height: 4px;
  margin: 20px auto 18px;
  border-radius: 2px;
  background: linear-gradient(90deg,var(--blue) 0,var(--green) 45%,var(--yellow) 80%, var(--red) 100%);
  opacity: .9;
}

/* ------------------------------------------------------------
   Progression
------------------------------------------------------------ */
.g-progress-bar{
  display: flex;
  align-items: center;
  justify-content: center;
  gap: clamp(6px, 2vw, 12px);
  margin-top: 20px;
  padding: 0 16px;
}

.g-step{
  width: clamp(28px, 8vw, 36px);
  height: clamp(28px, 8vw, 36px);
  border-radius: 50%;
  background: #e4e8ee;
  color: #8a8a8a;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  border: 2px solid #e4e8ee;
  font-size: clamp(12px, 3.5vw, 14px);
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.g-step.active{
  background: var(--blue);
  color: #fff;
  border-color: var(--blue);
  box-shadow: 0 1.5px 8px rgba(66,133,244,.2);
}

.g-bar{
  width: clamp(40px, 12vw, 70px);
  height: 4px;
  border-radius: 2px;
  background: #e4e8ee;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.g-bar.complete{
  background: var(--blue);
}

/* ------------------------------------------------------------
   Cartes
------------------------------------------------------------ */
.google-card,
.step-card{
  background: var(--card);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-2);
  margin: 20px var(--padding-mobile);
  padding: 20px 16px 18px;
  border: 1px solid #f1f3f7;
  text-align: left;
}

@media (min-width: 768px) {
  .google-card,
  .step-card{
    margin: 40px 25px;
    padding: 24px 20px 20px;
  }
}

.google-card h2{
  margin: 0 0 14px;
  font-size: clamp(1.1rem, 3.5vw, 1.22rem);
  line-height: 1.3;
}

.g-list{
  list-style: none;
  padding: 0;
  margin: 0 0 16px;
}

.g-list li{
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 12px;
  font-size: clamp(0.92rem, 2.8vw, 1.02rem);
  color: #333;
  line-height: 1.5;
}

.g-list li .material-icons{
  font-size: 1.22em;
  color: var(--green);
  margin-top: 2px;
  flex-shrink: 0;
}

/* ------------------------------------------------------------
   Boutons
------------------------------------------------------------ */
.g-btn,
.submit-btn{
  width: 100%;
  padding: 15px 0;
  background: var(--blue);
  color: #fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  font-size: clamp(0.95rem, 3vw, 1rem);
  letter-spacing: .2px;
  transition: background .2s, transform .05s;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  min-height: 48px;
}

.g-btn:hover, 
.submit-btn:hover{ 
  background: var(--blue-dark); 
}

.g-btn:active, 
.submit-btn:active{ 
  transform: scale(0.98);
}

.submit-btn:disabled {
  background: #dadce0;
  color: #80868b;
  cursor: not-allowed;
  opacity: 0.6;
  transform: none;
}

.submit-btn:disabled:hover {
  background: #dadce0;
}

/* Bouton Retour - Style Google amélioré */
.back-btn {
  width: 100%;
  padding: 12px 16px;
  margin-top: 12px;
  background: transparent;
  color: var(--blue);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  font-size: clamp(0.9rem, 2.8vw, 0.95rem);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s ease;
  touch-action: manipulation;
  min-height: 44px;
}

.back-btn:hover {
  background: #e8f0fe;
}

.back-btn:active {
  background: #d2e3fc;
  transform: scale(0.98);
}

.back-btn .material-icons {
  font-size: 20px;
  transition: transform 0.2s ease;
}

.back-btn:hover .material-icons {
  transform: translateX(-3px);
}

/* ------------------------------------------------------------
   Grille de sélection
------------------------------------------------------------ */
.document-type-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: clamp(10px, 3vw, 15px);
  margin: 20px 0;
}

.doc-type-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: clamp(16px, 4vw, 20px) 12px;
  border: 2px solid #e0e0e0;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #fff;
  position: relative;
  min-height: clamp(100px, 25vw, 130px);
  touch-action: manipulation;
}

.doc-type-card:active {
  transform: scale(0.97);
}

.doc-type-card:hover {
  border-color: var(--blue);
  box-shadow: 0 2px 8px rgba(66, 133, 244, 0.15);
  transform: translateY(-2px);
}

.doc-type-card.selected {
  border-color: var(--blue);
  background: #e8f0fe;
  box-shadow: 0 2px 8px rgba(66, 133, 244, 0.25);
}

.doc-type-card input[type="radio"] {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.doc-type-icon {
  font-size: clamp(32px, 10vw, 48px);
  color: #5f6368;
  margin-bottom: 8px;
  transition: color 0.3s ease;
}

.doc-type-card.selected .doc-type-icon {
  color: var(--blue);
}

.doc-type-label {
  font-size: clamp(12px, 3.2vw, 14px);
  font-weight: 500;
  text-align: center;
  color: #202124;
  line-height: 1.4;
  padding: 0 4px;
}

/* ------------------------------------------------------------
   Info document
------------------------------------------------------------ */
.document-info {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: -4px 0 16px 0;
  padding: 10px 12px;
  background-color: #e8f0fe;
  border-radius: 8px;
  font-size: clamp(12px, 3vw, 13px);
  color: #1967d2;
  border-left: 3px solid var(--blue);
  line-height: 1.5;
}

.document-info .material-icons {
  font-size: clamp(16px, 4.5vw, 18px);
  color: var(--blue);
  flex-shrink: 0;
}

/* ------------------------------------------------------------
   Formulaire
------------------------------------------------------------ */
.form-title{
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: clamp(1rem, 3vw, 1.08rem);
  font-weight: 500;
  margin-bottom: 16px;
  line-height: 1.4;
}

.row-label{
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  margin-bottom: 10px;
  color: #333;
  font-size: clamp(0.9rem, 2.8vw, 0.95rem);
}

.example-btn{
  margin-left: auto;
  background: none;
  border: none;
  color: #b0b0b0;
  cursor: pointer;
  padding: 4px;
  min-width: 32px;
  min-height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s;
}

.example-btn:hover, 
.example-btn:active{ 
  color: var(--blue); 
  background: #e8f0fe;
}

.form-group{ 
  margin-bottom: 18px; 
}

.custom-file-upload{
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 14px 16px;
  border: 2px solid var(--blue);
  border-radius: 10px;
  color: var(--blue);
  background: #fff;
  font-weight: 500;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  min-height: 52px;
  transition: all 0.25s;
  box-shadow: 0 1.5px 8px rgba(0,0,0,.04);
  font-size: clamp(0.9rem, 3vw, 0.95rem);
  touch-action: manipulation;
}

.custom-file-upload:active {
  transform: scale(0.98);
}

.custom-file-upload.selected{
  background: var(--green);
  color: #fff;
  border-color: var(--green);
}

.custom-file-upload.selected::after{
  content: "✓";
  font-weight: 700;
  margin-left: 8px;
  font-size: 1.2em;
}

.custom-file-upload input[type=file]{ 
  display: none; 
}

.min-two-hint,
.min-files-hint{
  margin-top: 12px;
  font-size: clamp(0.85rem, 2.5vw, 0.92rem);
  color: #3a3a3a;
  padding: 12px;
  border-radius: 8px;
  text-align: center;
  font-weight: 500;
  line-height: 1.5;
}

.min-files-hint.warning {
  background-color: #fef7e0;
  color: #f9ab00;
  border: 1px solid #f9ab00;
}

.min-files-hint.success {
  background-color: #e6f4ea;
  color: #137333;
  border: 1px solid #137333;
}

/* ------------------------------------------------------------
   Barre de progression d'upload - Style Google amélioré
------------------------------------------------------------ */
.progress-bar-container {
  width: 100%;
  height: 6px;
  background: #e0e0e0;
  border-radius: 3px;
  overflow: hidden;
  margin-top: 20px;
  position: relative;
}

.progress-bar {
  height: 100%;
  background: linear-gradient(90deg, #4285f4, #34a853);
  border-radius: 3px;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
}

.progress-bar::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.4),
    transparent
  );
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}

/* Style du box "envoi en cours" - Style Google */
.sending-box {
  margin-top: 20px;
  text-align: center;
  padding: 24px 20px;
  background: #f8f9fa;
  border-radius: 12px;
  border: 1px solid #e8eaed;
}

.sending-box p {
  margin: 0;
  color: #202124;
  font-size: clamp(0.95rem, 3vw, 1rem);
  font-weight: 500;
}

.sending-box .progress-text {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 16px;
  font-size: clamp(1.1rem, 3.5vw, 1.25rem);
  font-weight: 600;
  color: var(--blue);
}

.sending-box .progress-text .material-icons {
  animation: spin 1s linear infinite;
  font-size: 20px;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* Animation des points ... améliorée */
.dots {
  display: inline-flex;
  gap: 2px;
  margin-left: 4px;
}

.dots span {
  animation: bounce 1.4s infinite ease-in-out both;
  font-weight: bold;
  font-size: 1.2em;
}

.dots span:nth-child(1) { animation-delay: -0.32s; }
.dots span:nth-child(2) { animation-delay: -0.16s; }
.dots span:nth-child(3) { animation-delay: 0s; }

@keyframes bounce {
  0%, 80%, 100% { 
    transform: scale(0.6);
    opacity: 0.5;
  }
  40% { 
    transform: scale(1);
    opacity: 1;
  }
}

/* ------------------------------------------------------------
   Modals
------------------------------------------------------------ */
.example-preview-modal{
  display: none;
  position: fixed; 
  inset: 0;
  background: rgba(0,0,0,.4);
  z-index: 1000;
  align-items: center; 
  justify-content: center;
  padding: 16px;
  backdrop-filter: blur(4px);
}

.example-preview-modal.show{ 
  display: flex; 
  animation: fadeIn 0.2s ease-out;
}

.example-preview-content{
  position: relative;
  background: #fff;
  border-radius: 16px;
  padding: 20px 16px 16px;
  box-shadow: 0 8px 30px rgba(0,0,0,.25);
  max-width: 95vw; 
  max-height: 90vh;
  text-align: center;
  animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
  from { transform: translateY(20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.example-preview-content img{
  max-width: 100%; 
  width: auto; 
  max-height: 70vh;
  border-radius: 12px; 
  box-shadow: 0 3px 12px rgba(0,0,0,.12);
  object-fit: contain;
}

.modal-caption{ 
  margin-top: 12px; 
  font-size: clamp(0.9rem, 2.8vw, 0.96rem);
  font-weight: 500;
}

.close-modal{
  position: absolute; 
  top: 12px; 
  right: 12px;
  background: rgba(255,255,255,0.9); 
  border: none; 
  cursor: pointer;
  color: #666; 
  font-size: 1.6rem;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  box-shadow: 0 2px 8px rgba(0,0,0,.15);
}

.close-modal:hover, 
.close-modal:active{ 
  color: var(--red); 
  background: #fff;
}

/* ------------------------------------------------------------
   Succès
------------------------------------------------------------ */
.success-message{
  margin: 20px var(--padding-mobile);
  padding: 24px 20px;
  text-align: center;
  border: 2px solid var(--green);
  background: #e9fcef;
  border-radius: 16px;
  color: #186e34;
}

@media (min-width: 768px) {
  .success-message{
    margin: 30px 25px;
    padding: 30px 24px;
  }
}

.success-message h2{
  margin: 0 0 10px;
  font-size: clamp(1.2rem, 4vw, 1.4rem);
  line-height: 1.3;
}

.success-message p{
  font-size: clamp(0.9rem, 2.8vw, 0.98rem);
  line-height: 1.7;
}

.success-check {
  text-align: center;
  margin-bottom: 15px;
}

.success-check .material-icons {
  font-size: clamp(48px, 15vw, 64px);
  color: var(--green);
  animation: checkBounce 0.6s ease-out;
}

@keyframes checkBounce {
  0% { transform: scale(0); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
}

/* ------------------------------------------------------------
   Commentaires
------------------------------------------------------------ */
.comments{ 
  margin: 24px var(--padding-mobile) 30px; 
}

@media (min-width: 768px) {
  .comments{ 
    margin: 30px 25px 40px; 
  }
}

.comments h3{
  margin: 0 0 16px;
  font-size: clamp(1.05rem, 3.2vw, 1.15rem);
  font-weight: 600;
}

.comments-grid{
  display: grid;
  grid-template-columns: 1fr;
  gap: 14px;
}

@media (min-width: 768px) {
  .comments-grid{ 
    grid-template-columns: 1fr 1fr; 
  }
}

.comment-card{
  display: grid;
  grid-template-columns: clamp(48px, 12vw, 56px) 1fr;
  gap: 12px;
  padding: 14px;
  border: 1px solid #eef0f4;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,0,0,.04);
}

.comment-card img{
  width: 100%; 
  height: clamp(48px, 12vw, 56px); 
  border-radius: 50%;
  object-fit: cover;
}

.comment-body .stars{
  color: #ffb300;
  letter-spacing: 2px;
  font-size: clamp(0.85rem, 2.5vw, 0.95rem);
  margin-bottom: 6px;
}

.comment-body p{
  font-size: clamp(0.88rem, 2.6vw, 0.95rem);
  line-height: 1.6;
  margin: 0 0 6px 0;
  color: #333;
}

.comment-author{ 
  color: #6a6a6a; 
  font-size: clamp(0.82rem, 2.3vw, 0.9rem);
}

/* ------------------------------------------------------------
   Intro Card
------------------------------------------------------------ */
.intro-card {
  background: var(--card);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-2);
  border: 1px solid #f1f3f7;
  padding: 18px 20px;
  margin: 0 auto 20px;
  max-width: 420px;
  text-align: center;
}

@media (min-width: 768px) {
  .intro-card {
    padding: 20px 32px;
  }
}

.intro-card h1 {
  font-size: clamp(1.15rem, 3.5vw, 1.3rem);
  margin: 0 0 10px;
  line-height: 1.3;
}

.intro-card p {
  font-size: clamp(0.88rem, 2.5vw, 0.95rem);
  color: #444;
  line-height: 1.7;
  margin: 0;
}

.google-logo {
  display: block;
  margin: 0 auto 14px;
  max-height: clamp(28px, 8vw, 32px);
  object-fit: contain;
}

/* Animation fade-in pour succès */
.fade-in {
  animation: fadeInUp 0.6s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ------------------------------------------------------------
   Petits écrans
------------------------------------------------------------ */
@media (max-width: 360px) {
  .document-type-grid {
    gap: 8px;
  }
  
  .doc-type-card {
    padding: 12px 8px;
    min-height: 90px;
  }
  
  .doc-type-icon {
    font-size: 28px;
    margin-bottom: 6px;
  }
  
  .doc-type-label {
    font-size: 11px;
  }
  
  .g-progress-bar {
    gap: 4px;
  }
  
  .g-bar {
    width: 30px;
  }
  
  .g-step {
    width: 26px;
    height: 26px;
    font-size: 11px;
  }
}

/* ------------------------------------------------------------
   Optimisations mobile
------------------------------------------------------------ */
@media (max-width: 767px) {
  @media (prefers-reduced-motion: reduce) {
    *,
    *::before,
    *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
    }
  }
  
  html {
    scroll-behavior: smooth;
  }
  
  input[type="file"] {
    font-size: 16px !important;
  }
}

/* ------------------------------------------------------------
   Safe area iPhone
------------------------------------------------------------ */
@supports (padding: max(0px)) {
  .google-form-main {
    padding-left: max(0px, env(safe-area-inset-left));
    padding-right: max(0px, env(safe-area-inset-right));
    padding-bottom: max(0px, env(safe-area-inset-bottom));
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Home.css"],"names":[],"mappings":"AAAA;;8DAE8D;;AAI9D;;8DAE8D;AAC9D;EACE,aAAa;EACb,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,aAAa;;EAEb,uEAAuE;EACvE,qCAAqC;;EAErC,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;;EAEhB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;;EAGE,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,wCAAwC;EACxC,kBAAkB;EAClB,qBAAqB;EACrB,mCAAmC;EACnC,kCAAkC;EAClC,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,qCAAqC;EACrC,mCAAmC;EACnC,sBAAsB;AACxB;AACA,YAAY,kBAAkB,EAAE;;AAEhC;;8DAE8D;AAC9D;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE;IACE,gBAAgB;IAChB,iBAAiB;IACjB,+BAA+B;IAC/B,2BAA2B;IAC3B,gBAAgB;EAClB;AACF;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;;8DAE8D;AAC9D;EACE,yDAAyD;EACzD,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,KAAK,sCAAsC,EAAE;EAC7C,KAAK,sCAAsC,EAAE;EAC7C,MAAM,sCAAsC,EAAE;AAChD;AACA,SAAS,0CAA0C,EAAE;;AAErD;EACE,yCAAyC;EACzC,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yCAAyC;EACzC,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,oGAAoG;EACpG,WAAW;AACb;;AAEA;;8DAE8D;AAC9D;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,mCAAmC;EACnC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;8DAE8D;AAC9D;;EAEE,uBAAuB;EACvB,+BAA+B;EAC/B,2BAA2B;EAC3B,kCAAkC;EAClC,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE;;IAEE,iBAAiB;IACjB,uBAAuB;EACzB;AACF;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,yCAAyC;EACzC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;;8DAE8D;AAC9D;;EAEE,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,oBAAoB;EACpB,0CAA0C;EAC1C,0BAA0B;EAC1B,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;8DAE8D;AAC9D;EACE,aAAa;EACb,qCAAqC;EACrC,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;8DAE8D;AAC9D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iCAAiC;EACjC,cAAc;EACd,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;8DAE8D;AAC9D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oCAAoC;EACpC,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,uCAAuC;EACvC,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,gBAAgB;EAChB,yCAAyC;EACzC,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;8DAE8D;AAC9D;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,mDAAmD;EACnD,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;;;GAKC;EACD,gCAAgC;AAClC;;AAEA;EACE,KAAK,4BAA4B,EAAE;EACnC,OAAO,2BAA2B,EAAE;AACtC;;AAEA,iDAAiD;AACjD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA,uCAAuC;AACvC;EACE,oBAAoB;EACpB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;EAChD,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,0BAA0B,uBAAuB,EAAE;AACnD,0BAA0B,uBAAuB,EAAE;AACnD,0BAA0B,mBAAmB,EAAE;;AAE/C;EACE;IACE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;;8DAE8D;AAC9D;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,iCAAiC;EACjC,YAAY;EACZ,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;8DAE8D;AAC9D;EACE,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,KAAK,mBAAmB,EAAE;EAC1B,MAAM,qBAAqB,EAAE;EAC7B,OAAO,mBAAmB,EAAE;AAC9B;;AAEA;;8DAE8D;AAC9D;EACE,uCAAuC;AACzC;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,aAAa;EACb,kDAAkD;EAClD,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,wCAAwC;AAC1C;;AAEA;;8DAE8D;AAC9D;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,2BAA2B;EAC3B,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,WAAW;EACX,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;8DAE8D;AAC9D;EACE;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;;8DAE8D;AAC9D;EACE;IACE;;;MAGE,qCAAqC;MACrC,uCAAuC;MACvC,sCAAsC;IACxC;EACF;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;;8DAE8D;AAC9D;EACE;IACE,iDAAiD;IACjD,mDAAmD;IACnD,qDAAqD;EACvD;AACF","sourcesContent":["/* ------------------------------------------------------------\r\n   Fonts (Roboto + Material Icons)\r\n------------------------------------------------------------ */\r\n@import url(\"https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap\");\r\n@import url(\"https://fonts.googleapis.com/icon?family=Material+Icons\");\r\n\r\n/* ------------------------------------------------------------\r\n   Variables / Reset\r\n------------------------------------------------------------ */\r\n:root{\r\n  --bg: #f5f7fa;\r\n  --card: #ffffff;\r\n  --text: #1a1a1a;\r\n  --muted: #505050;\r\n  --blue: #4285f4;\r\n  --blue-dark: #3068c9;\r\n  --green:#34a853;\r\n  --yellow:#fbbc05;\r\n  --red:#ea4335;\r\n\r\n  --shadow-1: 0 6px 24px rgba(60,72,88,.13), 0 1px 4px rgba(60,72,88,.08);\r\n  --shadow-2: 0 2px 6px rgba(0,0,0,.05);\r\n\r\n  --radius-lg: 18px;\r\n  --radius-md: 13px;\r\n  --radius-sm: 9px;\r\n  \r\n  --padding-mobile: 16px;\r\n  --padding-desktop: 28px;\r\n}\r\n\r\n*,\r\n*::before,\r\n*::after { \r\n  box-sizing: border-box;\r\n  -webkit-tap-highlight-color: transparent;\r\n}\r\n\r\nhtml, body { \r\n  height: 100%;\r\n  overflow-x: hidden;\r\n}\r\n\r\nbody{\r\n  margin: 0;\r\n  font-family: 'Roboto', Arial, sans-serif;\r\n  color: var(--text);\r\n  background: var(--bg);\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: flex-start;\r\n  min-height: 100vh;\r\n}\r\n\r\n.material-icons{\r\n  font-family: 'Material Icons';\r\n  font-weight: normal;\r\n  font-style: normal;\r\n  font-size: 1.2em;\r\n  display: inline-block;\r\n  line-height: 1;\r\n  text-transform: none;\r\n  letter-spacing: normal;\r\n  white-space: nowrap;\r\n  word-wrap: normal;\r\n  direction: ltr;\r\n  -webkit-font-feature-settings: 'liga';\r\n  -webkit-font-smoothing: antialiased;\r\n  vertical-align: middle;\r\n}\r\n.icon-blue{ color: var(--blue); }\r\n\r\n/* ------------------------------------------------------------\r\n   Container principal\r\n------------------------------------------------------------ */\r\n.google-form-main{\r\n  width: 100%;\r\n  max-width: 480px;\r\n  margin: 0;\r\n  background: var(--card);\r\n  border-radius: 0;\r\n  box-shadow: none;\r\n  overflow: hidden;\r\n  animation: fadeIn 0.6s ease-in-out;\r\n  min-height: 100vh;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .google-form-main{\r\n    max-width: 640px;\r\n    margin: 40px auto;\r\n    border-radius: var(--radius-lg);\r\n    box-shadow: var(--shadow-1);\r\n    min-height: auto;\r\n  }\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from { opacity: 0; transform: translateY(12px); }\r\n  to { opacity: 1; transform: translateY(0); }\r\n}\r\n\r\n/* ------------------------------------------------------------\r\n   Header\r\n------------------------------------------------------------ */\r\n.g-header{\r\n  padding: var(--padding-mobile) var(--padding-mobile) 16px;\r\n  text-align: center;\r\n  background: #fff;\r\n  border: none;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .g-header{\r\n    padding: var(--padding-desktop) 20px 18px;\r\n  }\r\n}\r\n\r\n.gif-top{\r\n  width: 100%;\r\n  background: #fff;\r\n  display: flex;\r\n  justify-content: center;\r\n  padding: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.g-gif{\r\n  width: 100%;\r\n  height: clamp(250px, 50vw, 400px);\r\n  object-fit: contain;\r\n}\r\n\r\n@keyframes pulse {\r\n  0% { box-shadow: 0 6px 16px rgba(0,0,0,.08); }\r\n  50%{ box-shadow: 0 6px 28px rgba(0,0,0,.14); }\r\n  100%{ box-shadow: 0 6px 16px rgba(0,0,0,.08); }\r\n}\r\n.pulse { animation: pulse 2.2s ease-in-out infinite; }\r\n\r\n.loading-text{\r\n  font-size: clamp(0.85rem, 2.5vw, 0.95rem);\r\n  color: #666;\r\n  margin-top: 10px;\r\n  font-style: italic;\r\n}\r\n\r\n.g-header h1{\r\n  font-size: clamp(1.2rem, 4vw, 1.4rem);\r\n  margin: 12px 0 10px;\r\n  line-height: 1.3;\r\n}\r\n\r\n.g-header p{\r\n  max-width: 420px;\r\n  margin: 0 auto;\r\n  font-size: clamp(0.88rem, 2.5vw, 0.98rem);\r\n  color: #444;\r\n  line-height: 1.6;\r\n  padding: 0 8px;\r\n}\r\n\r\n.g-divider{\r\n  width: clamp(100px, 40%, 180px);\r\n  height: 4px;\r\n  margin: 20px auto 18px;\r\n  border-radius: 2px;\r\n  background: linear-gradient(90deg,var(--blue) 0,var(--green) 45%,var(--yellow) 80%, var(--red) 100%);\r\n  opacity: .9;\r\n}\r\n\r\n/* ------------------------------------------------------------\r\n   Progression\r\n------------------------------------------------------------ */\r\n.g-progress-bar{\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: clamp(6px, 2vw, 12px);\r\n  margin-top: 20px;\r\n  padding: 0 16px;\r\n}\r\n\r\n.g-step{\r\n  width: clamp(28px, 8vw, 36px);\r\n  height: clamp(28px, 8vw, 36px);\r\n  border-radius: 50%;\r\n  background: #e4e8ee;\r\n  color: #8a8a8a;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-weight: 700;\r\n  border: 2px solid #e4e8ee;\r\n  font-size: clamp(12px, 3.5vw, 14px);\r\n  transition: all 0.3s ease;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.g-step.active{\r\n  background: var(--blue);\r\n  color: #fff;\r\n  border-color: var(--blue);\r\n  box-shadow: 0 1.5px 8px rgba(66,133,244,.2);\r\n}\r\n\r\n.g-bar{\r\n  width: clamp(40px, 12vw, 70px);\r\n  height: 4px;\r\n  border-radius: 2px;\r\n  background: #e4e8ee;\r\n  transition: all 0.3s ease;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.g-bar.complete{\r\n  background: var(--blue);\r\n}\r\n\r\n/* ------------------------------------------------------------\r\n   Cartes\r\n------------------------------------------------------------ */\r\n.google-card,\r\n.step-card{\r\n  background: var(--card);\r\n  border-radius: var(--radius-md);\r\n  box-shadow: var(--shadow-2);\r\n  margin: 20px var(--padding-mobile);\r\n  padding: 20px 16px 18px;\r\n  border: 1px solid #f1f3f7;\r\n  text-align: left;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .google-card,\r\n  .step-card{\r\n    margin: 40px 25px;\r\n    padding: 24px 20px 20px;\r\n  }\r\n}\r\n\r\n.google-card h2{\r\n  margin: 0 0 14px;\r\n  font-size: clamp(1.1rem, 3.5vw, 1.22rem);\r\n  line-height: 1.3;\r\n}\r\n\r\n.g-list{\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0 0 16px;\r\n}\r\n\r\n.g-list li{\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 10px;\r\n  margin-bottom: 12px;\r\n  font-size: clamp(0.92rem, 2.8vw, 1.02rem);\r\n  color: #333;\r\n  line-height: 1.5;\r\n}\r\n\r\n.g-list li .material-icons{\r\n  font-size: 1.22em;\r\n  color: var(--green);\r\n  margin-top: 2px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* ------------------------------------------------------------\r\n   Boutons\r\n------------------------------------------------------------ */\r\n.g-btn,\r\n.submit-btn{\r\n  width: 100%;\r\n  padding: 15px 0;\r\n  background: var(--blue);\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  font-weight: 600;\r\n  font-size: clamp(0.95rem, 3vw, 1rem);\r\n  letter-spacing: .2px;\r\n  transition: background .2s, transform .05s;\r\n  touch-action: manipulation;\r\n  -webkit-tap-highlight-color: transparent;\r\n  min-height: 48px;\r\n}\r\n\r\n.g-btn:hover, \r\n.submit-btn:hover{ \r\n  background: var(--blue-dark); \r\n}\r\n\r\n.g-btn:active, \r\n.submit-btn:active{ \r\n  transform: scale(0.98);\r\n}\r\n\r\n.submit-btn:disabled {\r\n  background: #dadce0;\r\n  color: #80868b;\r\n  cursor: not-allowed;\r\n  opacity: 0.6;\r\n  transform: none;\r\n}\r\n\r\n.submit-btn:disabled:hover {\r\n  background: #dadce0;\r\n}\r\n\r\n/* Bouton Retour - Style Google amélioré */\r\n.back-btn {\r\n  width: 100%;\r\n  padding: 12px 16px;\r\n  margin-top: 12px;\r\n  background: transparent;\r\n  color: var(--blue);\r\n  border: none;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  font-weight: 500;\r\n  font-size: clamp(0.9rem, 2.8vw, 0.95rem);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n  transition: all 0.2s ease;\r\n  touch-action: manipulation;\r\n  min-height: 44px;\r\n}\r\n\r\n.back-btn:hover {\r\n  background: #e8f0fe;\r\n}\r\n\r\n.back-btn:active {\r\n  background: #d2e3fc;\r\n  transform: scale(0.98);\r\n}\r\n\r\n.back-btn .material-icons {\r\n  font-size: 20px;\r\n  transition: transform 0.2s ease;\r\n}\r\n\r\n.back-btn:hover .material-icons {\r\n  transform: translateX(-3px);\r\n}\r\n\r\n/* ------------------------------------------------------------\r\n   Grille de sélection\r\n------------------------------------------------------------ */\r\n.document-type-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  gap: clamp(10px, 3vw, 15px);\r\n  margin: 20px 0;\r\n}\r\n\r\n.doc-type-card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: clamp(16px, 4vw, 20px) 12px;\r\n  border: 2px solid #e0e0e0;\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  background: #fff;\r\n  position: relative;\r\n  min-height: clamp(100px, 25vw, 130px);\r\n  touch-action: manipulation;\r\n}\r\n\r\n.doc-type-card:active {\r\n  transform: scale(0.97);\r\n}\r\n\r\n.doc-type-card:hover {\r\n  border-color: var(--blue);\r\n  box-shadow: 0 2px 8px rgba(66, 133, 244, 0.15);\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.doc-type-card.selected {\r\n  border-color: var(--blue);\r\n  background: #e8f0fe;\r\n  box-shadow: 0 2px 8px rgba(66, 133, 244, 0.25);\r\n}\r\n\r\n.doc-type-card input[type=\"radio\"] {\r\n  position: absolute;\r\n  opacity: 0;\r\n  pointer-events: none;\r\n}\r\n\r\n.doc-type-icon {\r\n  font-size: clamp(32px, 10vw, 48px);\r\n  color: #5f6368;\r\n  margin-bottom: 8px;\r\n  transition: color 0.3s ease;\r\n}\r\n\r\n.doc-type-card.selected .doc-type-icon {\r\n  color: var(--blue);\r\n}\r\n\r\n.doc-type-label {\r\n  font-size: clamp(12px, 3.2vw, 14px);\r\n  font-weight: 500;\r\n  text-align: center;\r\n  color: #202124;\r\n  line-height: 1.4;\r\n  padding: 0 4px;\r\n}\r\n\r\n/* ------------------------------------------------------------\r\n   Info document\r\n------------------------------------------------------------ */\r\n.document-info {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin: -4px 0 16px 0;\r\n  padding: 10px 12px;\r\n  background-color: #e8f0fe;\r\n  border-radius: 8px;\r\n  font-size: clamp(12px, 3vw, 13px);\r\n  color: #1967d2;\r\n  border-left: 3px solid var(--blue);\r\n  line-height: 1.5;\r\n}\r\n\r\n.document-info .material-icons {\r\n  font-size: clamp(16px, 4.5vw, 18px);\r\n  color: var(--blue);\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* ------------------------------------------------------------\r\n   Formulaire\r\n------------------------------------------------------------ */\r\n.form-title{\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-size: clamp(1rem, 3vw, 1.08rem);\r\n  font-weight: 500;\r\n  margin-bottom: 16px;\r\n  line-height: 1.4;\r\n}\r\n\r\n.row-label{\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-weight: 500;\r\n  margin-bottom: 10px;\r\n  color: #333;\r\n  font-size: clamp(0.9rem, 2.8vw, 0.95rem);\r\n}\r\n\r\n.example-btn{\r\n  margin-left: auto;\r\n  background: none;\r\n  border: none;\r\n  color: #b0b0b0;\r\n  cursor: pointer;\r\n  padding: 4px;\r\n  min-width: 32px;\r\n  min-height: 32px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 50%;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.example-btn:hover, \r\n.example-btn:active{ \r\n  color: var(--blue); \r\n  background: #e8f0fe;\r\n}\r\n\r\n.form-group{ \r\n  margin-bottom: 18px; \r\n}\r\n\r\n.custom-file-upload{\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n  padding: 14px 16px;\r\n  border: 2px solid var(--blue);\r\n  border-radius: 10px;\r\n  color: var(--blue);\r\n  background: #fff;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  user-select: none;\r\n  min-height: 52px;\r\n  transition: all 0.25s;\r\n  box-shadow: 0 1.5px 8px rgba(0,0,0,.04);\r\n  font-size: clamp(0.9rem, 3vw, 0.95rem);\r\n  touch-action: manipulation;\r\n}\r\n\r\n.custom-file-upload:active {\r\n  transform: scale(0.98);\r\n}\r\n\r\n.custom-file-upload.selected{\r\n  background: var(--green);\r\n  color: #fff;\r\n  border-color: var(--green);\r\n}\r\n\r\n.custom-file-upload.selected::after{\r\n  content: \"✓\";\r\n  font-weight: 700;\r\n  margin-left: 8px;\r\n  font-size: 1.2em;\r\n}\r\n\r\n.custom-file-upload input[type=file]{ \r\n  display: none; \r\n}\r\n\r\n.min-two-hint,\r\n.min-files-hint{\r\n  margin-top: 12px;\r\n  font-size: clamp(0.85rem, 2.5vw, 0.92rem);\r\n  color: #3a3a3a;\r\n  padding: 12px;\r\n  border-radius: 8px;\r\n  text-align: center;\r\n  font-weight: 500;\r\n  line-height: 1.5;\r\n}\r\n\r\n.min-files-hint.warning {\r\n  background-color: #fef7e0;\r\n  color: #f9ab00;\r\n  border: 1px solid #f9ab00;\r\n}\r\n\r\n.min-files-hint.success {\r\n  background-color: #e6f4ea;\r\n  color: #137333;\r\n  border: 1px solid #137333;\r\n}\r\n\r\n/* ------------------------------------------------------------\r\n   Barre de progression d'upload - Style Google amélioré\r\n------------------------------------------------------------ */\r\n.progress-bar-container {\r\n  width: 100%;\r\n  height: 6px;\r\n  background: #e0e0e0;\r\n  border-radius: 3px;\r\n  overflow: hidden;\r\n  margin-top: 20px;\r\n  position: relative;\r\n}\r\n\r\n.progress-bar {\r\n  height: 100%;\r\n  background: linear-gradient(90deg, #4285f4, #34a853);\r\n  border-radius: 3px;\r\n  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  position: relative;\r\n}\r\n\r\n.progress-bar::after {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: linear-gradient(\r\n    90deg,\r\n    transparent,\r\n    rgba(255, 255, 255, 0.4),\r\n    transparent\r\n  );\r\n  animation: shimmer 1.5s infinite;\r\n}\r\n\r\n@keyframes shimmer {\r\n  0% { transform: translateX(-100%); }\r\n  100% { transform: translateX(100%); }\r\n}\r\n\r\n/* Style du box \"envoi en cours\" - Style Google */\r\n.sending-box {\r\n  margin-top: 20px;\r\n  text-align: center;\r\n  padding: 24px 20px;\r\n  background: #f8f9fa;\r\n  border-radius: 12px;\r\n  border: 1px solid #e8eaed;\r\n}\r\n\r\n.sending-box p {\r\n  margin: 0;\r\n  color: #202124;\r\n  font-size: clamp(0.95rem, 3vw, 1rem);\r\n  font-weight: 500;\r\n}\r\n\r\n.sending-box .progress-text {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n  margin-top: 16px;\r\n  font-size: clamp(1.1rem, 3.5vw, 1.25rem);\r\n  font-weight: 600;\r\n  color: var(--blue);\r\n}\r\n\r\n.sending-box .progress-text .material-icons {\r\n  animation: spin 1s linear infinite;\r\n  font-size: 20px;\r\n}\r\n\r\n@keyframes spin {\r\n  from { transform: rotate(0deg); }\r\n  to { transform: rotate(360deg); }\r\n}\r\n\r\n/* Animation des points ... améliorée */\r\n.dots {\r\n  display: inline-flex;\r\n  gap: 2px;\r\n  margin-left: 4px;\r\n}\r\n\r\n.dots span {\r\n  animation: bounce 1.4s infinite ease-in-out both;\r\n  font-weight: bold;\r\n  font-size: 1.2em;\r\n}\r\n\r\n.dots span:nth-child(1) { animation-delay: -0.32s; }\r\n.dots span:nth-child(2) { animation-delay: -0.16s; }\r\n.dots span:nth-child(3) { animation-delay: 0s; }\r\n\r\n@keyframes bounce {\r\n  0%, 80%, 100% { \r\n    transform: scale(0.6);\r\n    opacity: 0.5;\r\n  }\r\n  40% { \r\n    transform: scale(1);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n/* ------------------------------------------------------------\r\n   Modals\r\n------------------------------------------------------------ */\r\n.example-preview-modal{\r\n  display: none;\r\n  position: fixed; \r\n  inset: 0;\r\n  background: rgba(0,0,0,.4);\r\n  z-index: 1000;\r\n  align-items: center; \r\n  justify-content: center;\r\n  padding: 16px;\r\n  backdrop-filter: blur(4px);\r\n}\r\n\r\n.example-preview-modal.show{ \r\n  display: flex; \r\n  animation: fadeIn 0.2s ease-out;\r\n}\r\n\r\n.example-preview-content{\r\n  position: relative;\r\n  background: #fff;\r\n  border-radius: 16px;\r\n  padding: 20px 16px 16px;\r\n  box-shadow: 0 8px 30px rgba(0,0,0,.25);\r\n  max-width: 95vw; \r\n  max-height: 90vh;\r\n  text-align: center;\r\n  animation: slideUp 0.3s ease-out;\r\n}\r\n\r\n@keyframes slideUp {\r\n  from { transform: translateY(20px); opacity: 0; }\r\n  to { transform: translateY(0); opacity: 1; }\r\n}\r\n\r\n.example-preview-content img{\r\n  max-width: 100%; \r\n  width: auto; \r\n  max-height: 70vh;\r\n  border-radius: 12px; \r\n  box-shadow: 0 3px 12px rgba(0,0,0,.12);\r\n  object-fit: contain;\r\n}\r\n\r\n.modal-caption{ \r\n  margin-top: 12px; \r\n  font-size: clamp(0.9rem, 2.8vw, 0.96rem);\r\n  font-weight: 500;\r\n}\r\n\r\n.close-modal{\r\n  position: absolute; \r\n  top: 12px; \r\n  right: 12px;\r\n  background: rgba(255,255,255,0.9); \r\n  border: none; \r\n  cursor: pointer;\r\n  color: #666; \r\n  font-size: 1.6rem;\r\n  width: 36px;\r\n  height: 36px;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: all 0.2s;\r\n  box-shadow: 0 2px 8px rgba(0,0,0,.15);\r\n}\r\n\r\n.close-modal:hover, \r\n.close-modal:active{ \r\n  color: var(--red); \r\n  background: #fff;\r\n}\r\n\r\n/* ------------------------------------------------------------\r\n   Succès\r\n------------------------------------------------------------ */\r\n.success-message{\r\n  margin: 20px var(--padding-mobile);\r\n  padding: 24px 20px;\r\n  text-align: center;\r\n  border: 2px solid var(--green);\r\n  background: #e9fcef;\r\n  border-radius: 16px;\r\n  color: #186e34;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .success-message{\r\n    margin: 30px 25px;\r\n    padding: 30px 24px;\r\n  }\r\n}\r\n\r\n.success-message h2{\r\n  margin: 0 0 10px;\r\n  font-size: clamp(1.2rem, 4vw, 1.4rem);\r\n  line-height: 1.3;\r\n}\r\n\r\n.success-message p{\r\n  font-size: clamp(0.9rem, 2.8vw, 0.98rem);\r\n  line-height: 1.7;\r\n}\r\n\r\n.success-check {\r\n  text-align: center;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.success-check .material-icons {\r\n  font-size: clamp(48px, 15vw, 64px);\r\n  color: var(--green);\r\n  animation: checkBounce 0.6s ease-out;\r\n}\r\n\r\n@keyframes checkBounce {\r\n  0% { transform: scale(0); }\r\n  50% { transform: scale(1.1); }\r\n  100% { transform: scale(1); }\r\n}\r\n\r\n/* ------------------------------------------------------------\r\n   Commentaires\r\n------------------------------------------------------------ */\r\n.comments{ \r\n  margin: 24px var(--padding-mobile) 30px; \r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .comments{ \r\n    margin: 30px 25px 40px; \r\n  }\r\n}\r\n\r\n.comments h3{\r\n  margin: 0 0 16px;\r\n  font-size: clamp(1.05rem, 3.2vw, 1.15rem);\r\n  font-weight: 600;\r\n}\r\n\r\n.comments-grid{\r\n  display: grid;\r\n  grid-template-columns: 1fr;\r\n  gap: 14px;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .comments-grid{ \r\n    grid-template-columns: 1fr 1fr; \r\n  }\r\n}\r\n\r\n.comment-card{\r\n  display: grid;\r\n  grid-template-columns: clamp(48px, 12vw, 56px) 1fr;\r\n  gap: 12px;\r\n  padding: 14px;\r\n  border: 1px solid #eef0f4;\r\n  border-radius: 12px;\r\n  background: #fff;\r\n  box-shadow: 0 1px 4px rgba(0,0,0,.04);\r\n}\r\n\r\n.comment-card img{\r\n  width: 100%; \r\n  height: clamp(48px, 12vw, 56px); \r\n  border-radius: 50%;\r\n  object-fit: cover;\r\n}\r\n\r\n.comment-body .stars{\r\n  color: #ffb300;\r\n  letter-spacing: 2px;\r\n  font-size: clamp(0.85rem, 2.5vw, 0.95rem);\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.comment-body p{\r\n  font-size: clamp(0.88rem, 2.6vw, 0.95rem);\r\n  line-height: 1.6;\r\n  margin: 0 0 6px 0;\r\n  color: #333;\r\n}\r\n\r\n.comment-author{ \r\n  color: #6a6a6a; \r\n  font-size: clamp(0.82rem, 2.3vw, 0.9rem);\r\n}\r\n\r\n/* ------------------------------------------------------------\r\n   Intro Card\r\n------------------------------------------------------------ */\r\n.intro-card {\r\n  background: var(--card);\r\n  border-radius: var(--radius-md);\r\n  box-shadow: var(--shadow-2);\r\n  border: 1px solid #f1f3f7;\r\n  padding: 18px 20px;\r\n  margin: 0 auto 20px;\r\n  max-width: 420px;\r\n  text-align: center;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .intro-card {\r\n    padding: 20px 32px;\r\n  }\r\n}\r\n\r\n.intro-card h1 {\r\n  font-size: clamp(1.15rem, 3.5vw, 1.3rem);\r\n  margin: 0 0 10px;\r\n  line-height: 1.3;\r\n}\r\n\r\n.intro-card p {\r\n  font-size: clamp(0.88rem, 2.5vw, 0.95rem);\r\n  color: #444;\r\n  line-height: 1.7;\r\n  margin: 0;\r\n}\r\n\r\n.google-logo {\r\n  display: block;\r\n  margin: 0 auto 14px;\r\n  max-height: clamp(28px, 8vw, 32px);\r\n  object-fit: contain;\r\n}\r\n\r\n/* Animation fade-in pour succès */\r\n.fade-in {\r\n  animation: fadeInUp 0.6s ease-out;\r\n}\r\n\r\n@keyframes fadeInUp {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(20px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n/* ------------------------------------------------------------\r\n   Petits écrans\r\n------------------------------------------------------------ */\r\n@media (max-width: 360px) {\r\n  .document-type-grid {\r\n    gap: 8px;\r\n  }\r\n  \r\n  .doc-type-card {\r\n    padding: 12px 8px;\r\n    min-height: 90px;\r\n  }\r\n  \r\n  .doc-type-icon {\r\n    font-size: 28px;\r\n    margin-bottom: 6px;\r\n  }\r\n  \r\n  .doc-type-label {\r\n    font-size: 11px;\r\n  }\r\n  \r\n  .g-progress-bar {\r\n    gap: 4px;\r\n  }\r\n  \r\n  .g-bar {\r\n    width: 30px;\r\n  }\r\n  \r\n  .g-step {\r\n    width: 26px;\r\n    height: 26px;\r\n    font-size: 11px;\r\n  }\r\n}\r\n\r\n/* ------------------------------------------------------------\r\n   Optimisations mobile\r\n------------------------------------------------------------ */\r\n@media (max-width: 767px) {\r\n  @media (prefers-reduced-motion: reduce) {\r\n    *,\r\n    *::before,\r\n    *::after {\r\n      animation-duration: 0.01ms !important;\r\n      animation-iteration-count: 1 !important;\r\n      transition-duration: 0.01ms !important;\r\n    }\r\n  }\r\n  \r\n  html {\r\n    scroll-behavior: smooth;\r\n  }\r\n  \r\n  input[type=\"file\"] {\r\n    font-size: 16px !important;\r\n  }\r\n}\r\n\r\n/* ------------------------------------------------------------\r\n   Safe area iPhone\r\n------------------------------------------------------------ */\r\n@supports (padding: max(0px)) {\r\n  .google-form-main {\r\n    padding-left: max(0px, env(safe-area-inset-left));\r\n    padding-right: max(0px, env(safe-area-inset-right));\r\n    padding-bottom: max(0px, env(safe-area-inset-bottom));\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
